import { AxiosResponse, AxiosError } from 'axios';

// Constants
import {
    RE_ENTRY_WARNING_LOAD_REQUESTED,
    RE_ENTRY_WARNING_LOAD_SUCCEEDED,
    RE_ENTRY_WARNING_LOAD_FAILED,
    RE_ENTRY_WARNING_LOAD_CANCELED,
    RE_ENTRY_WARNING_SET,
    RE_ENTRY_WARNING_RESET
} from './constants';

// Types
import {
    RequestedLoadReEntryWarningAction,
    SucceededLoadReEntryWarningAction,
    FailedLoadReEntryWarningAction,
    CanceledLoadReEntryWarningAction,
    SetReEntryWarningAction,
    ResetReEntryWarningAction,
    ReEntryWarningState
} from './types';

export function requestLoadReEntryWarning(
    entityId: number,
    startDate: string,
    endDate: string
): RequestedLoadReEntryWarningAction {
    return {
        type: RE_ENTRY_WARNING_LOAD_REQUESTED,
        payload: {
            entityId,
            startDate,
            endDate
        }
    };
}

export function succeededLoadReEntryWarning(
    response: AxiosResponse
): SucceededLoadReEntryWarningAction {
    return {
        type: RE_ENTRY_WARNING_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadReEntryWarning(
    error: AxiosError
): FailedLoadReEntryWarningAction {
    return {
        type: RE_ENTRY_WARNING_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function cancelLoadReEntryWarning(): CanceledLoadReEntryWarningAction {
    return {
        type: RE_ENTRY_WARNING_LOAD_CANCELED
    };
}

export function setReEntryWarning(
    isWarning: ReEntryWarningState
): SetReEntryWarningAction {
    return {
        type: RE_ENTRY_WARNING_SET,
        payload: isWarning
    };
}

export function resetReEntryWarning(): ResetReEntryWarningAction {
    return {
        type: RE_ENTRY_WARNING_RESET
    };
}
